
<div *ngIf="_commonService.showLangSwitcher" class="lang-switch">
  <mat-select disableRipple disableOptionCentering panelClass="lang-select-panel" class="lang-select" [value]="_commonService.language" (selectionChange)="switchLanguage($event.value)">
    <mat-option value="En">English</mat-option>
    <mat-option value="ar">عربي</mat-option>
  </mat-select>
  </div>
<!-- <div *ngIf="_processShellService.isCommonHeaderVisible()" [ngClass]="{'onboarding-container' : this._commonService.isDesktop()}" >
  <header class="rm-header-icon">
  <ng-container *ngIf="_commonService.getApplicationMode() == 'RM'; else normalApp">
    <fpx-button *ngIf="_processShellService.getBodNumber()!=2 ||  _processShellService.screenMode == 'rm-view-mode'" className="back" btnType="button" label="Back"
      (onClick)="_shellService.goBack()"></fpx-button>
    <fpx-button className="home" btnType="button" label="Home" (onClick)="_shellService.goHome()"></fpx-button>
  </ng-container>

  <ng-template #normalApp>
    <box class="header-inner">
      <h1 class="logo"><span>Bank</span></h1>
    </box>
  </ng-template>
</header></div> -->

<div class="cbx-main" [dir]="documentDirection">
  <router-outlet #outlet="outlet"></router-outlet>
</div>

<ng-container *ngIf="loading$ | async" >
  <div class="spinner">
      <img src="./assets/images/loading.svg" alt="loading_svg" />
  </div>
</ng-container>

<div [dir]="documentDirection" style="display: none;" class="ws-loader" id="wsloader"></div>

<!--SANTHOSH 30/09/2021 BEGIN-->
<ng-container *ngIf="services.isMobile()">
  <!-- <div [dir]="documentDirection" id="sessonsoon"> -->
    <!-- <div class="sesssionpop">
      <button class="clsbutton"  clickable (click)="continueSession()"><svg height="11.536" viewBox="0 0 11.535 11.536" width="11.535"
          xmlns="http://www.w3.org/2000/svg">
          <g data-name="Group 10749" id="Group_10749" transform="translate(1.768 1.768)">
            <g data-name="Group 10713" id="Group_10713">
              <line data-name="Line 325" fill="none" id="Line_325" stroke="#00a10b" stroke-linecap="round"
                stroke-width="2.5" x2="8" y2="8"></line>
              <line data-name="Line 326" fill="none" id="Line_326" stroke="#00a10b" stroke-linecap="round"
                stroke-width="2.5" x1="8" y2="8"></line>
            </g>
          </g>
        </svg></button>
      <div class="sessionstaion">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="52.847" viewBox="0 0 60 52.847">

          <path id="np_attention_2923438_000000"
            d="M61.341,48.8,39.432,12.113a8.119,8.119,0,0,0-13.891,0L3.633,48.8a8.121,8.121,0,0,0,6.946,12.248H54.4a7.894,7.894,0,0,0,7.01-4.1,8,8,0,0,0-.064-8.144ZM32.487,52.461A3.409,3.409,0,1,1,35.9,49.052,3.394,3.394,0,0,1,32.487,52.461ZM36.15,26.509l-1.2,14.081A2.462,2.462,0,0,1,32.3,42.8a2.43,2.43,0,0,1-2.21-2.21l-1.2-14.081a3.676,3.676,0,0,1,7.325-.631,2.041,2.041,0,0,0-.067.631Z"
            transform="translate(-2.489 -8.199)" fill="#00a10b" />

        </svg>
      </div>
   session set txt start-->
     <!-- <div class="sessionsettxt">
        <h3>{{'SESSIONTIMERLOGOUT.title'| translate}}</h3>
        <p>{{'SESSIONTIMERLOGOUT.sessionTimer'| translate}} <span><span id="sessionTimer">01:12</span> {{'SESSIONTIMERLOGOUT.min'| translate}}</span></p>
        <a href="javascript:void(0)"  clickable (click)="killSession()">{{'SESSIONTIMERLOGOUT.logout'| translate}}</a>


      </div>
      <a href="javascript:void(0)"  clickable (click)="continueSession()" class="buttonsbom">{{'SESSIONTIMERLOGOUT.continue'| translate}}</a>
    </div> -->
  <!-- </div> -->
</ng-container>
<ng-container *ngIf="services.isDesktop()">
  <!-- <app-popup-inline [dir]="documentDirection" (close)="continueSession()" customClass="sesssionpop" customName="sessonsoon">
    <div class="sessionstaion">
      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet" viewBox="0 0 59.998 52.847">
        <path id="np_attention_2923438_000000"
          d="M61.341,48.8,39.432,12.113a8.119,8.119,0,0,0-13.891,0L3.633,48.8a8.121,8.121,0,0,0,6.946,12.248H54.4a7.894,7.894,0,0,0,7.01-4.1,8,8,0,0,0-.064-8.144ZM32.487,52.461A3.409,3.409,0,1,1,35.9,49.052,3.394,3.394,0,0,1,32.487,52.461ZM36.15,26.509l-1.2,14.081A2.462,2.462,0,0,1,32.3,42.8a2.43,2.43,0,0,1-2.21-2.21l-1.2-14.081a3.676,3.676,0,0,1,7.325-.631,2.041,2.041,0,0,0-.067.631Z"
          transform="translate(-2.489 -8.199)" fill="#00a10b" />
      </svg>
    </div> -->
    <!--session set txt start-->
    <!-- <div class="sessionsettxt">
      <h3>{{'SESSIONTIMERLOGOUT.title'| translate}}</h3> -->
      <!-- <p>{{'SESSIONTIMERLOGOUT.sessionTimer'| translate}} <span><span id="sessionTimer">01:12</span> {{'SESSIONTIMERLOGOUT.min'| translate}}</span></p> -->
      <!-- <button class="btn-link" clickable (click)="killSession()">{{'SESSIONTIMERLOGOUT.logout'| translate}}</button>
    </div>
    <button class="button-common button40" clickable (click)="continueSession()"><span>{{'SESSIONTIMERLOGOUT.continue'| translate}}</span></button>
  </app-popup-inline> -->
</ng-container>

<!--session set txt end-->
<!--SANTHOSH 30/09/2021 END-->

<div class="d-flex-end" *ngIf="showResumeWarning">
  <div class="cards">
    <i class="icon-spacing">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g id="ic-ok" transform="translate(0 -12)">
          <g id="ok" transform="translate(0 12)">
            <g id="Oval_55" data-name="Oval 55">
              <g id="Oval_55-2" data-name="Oval 55" fill="#00a10b" stroke="#00a10b" stroke-miterlimit="10"
                stroke-width="2">
                <circle cx="30" cy="30" r="30" stroke="none" />
                <circle cx="30" cy="30" r="29" fill="none" />
              </g>
              <circle id="Oval_55-3" data-name="Oval 55" cx="30" cy="30" r="30" fill="none" />
            </g>
            <path id="Path_3" data-name="Path 3" d="M0,10.672l6.621,6.4L24.178,0" transform="translate(18.622 21.889)"
              fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
              stroke-width="4" />
          </g>
        </g>
      </svg>
    </i>

    <h2 class="title-spacing title">Welcome back</h2>
    <p class="title-spacing text-detail">
      You have started a <span class="stronger">product subscription.</span> in case you want to resume please press continue.
    </p>
    <button class="btn-link bave-as-tmpl-btn"  clickable (click)="gotoAccountOpening()">
      Continue later
    </button>
    <button class="button-common button40 outline btn-spacing"  clickable (click)="resumeOnboarding()"><span>Continue</span></button>
  </div>
</div>

<form-control-templates></form-control-templates>
<form-dropdown-templates></form-dropdown-templates>
<form-cards-templates></form-cards-templates>
<form-ro-grid-templates></form-ro-grid-templates>
